import { useQuery } from '@tanstack/react-query';

import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_DOCUMENT_BASE_URL } from '.';

import { TreatmentResponse } from '../types/treatment';

const url = `${INBOX_DOCUMENT_BASE_URL}/:inboxDocumentId/transactions`;

type GetTransactionsResponse = {
  transactions: TreatmentResponse[];
};

export const getTransactions = (inboxDocumentId: number): Promise<GetTransactionsResponse> => {
  return axios.get(generateRoutePath(url, { inboxDocumentId }));
};

export const quickbooksTreatmentsKeys = {
  all: ['transactions'] as const,
  detail: (inboxDocumentId: number) => [INBOX_API_KEY, ...quickbooksTreatmentsKeys.all, inboxDocumentId] as const,
};

type QueryFnType = typeof getTransactions;

type useTreatmentsOptions = {
  inboxDocumentId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useQuickbookTransactions = ({ inboxDocumentId, config }: useTreatmentsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...quickbooksTreatmentsKeys.all, inboxDocumentId],
    queryFn: () => getTransactions(inboxDocumentId),
    staleTime: Infinity,
    ...config,
  });
};
